// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__9pPXt","iconWithCounter":"styles_iconWithCounter__OyC9L","counterForLabel":"styles_counterForLabel__yfsSK","counterForIcon":"styles_counterForIcon__7LFJi"};